import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import Buefy from "buefy";
import VueMask from "v-mask";
import VeeValidate from "./plugins/vee-validate";
import FontAwesome from "./plugins/font-awesome";
import PortalVue from "portal-vue";
import VueObserveVisibility from "vue-observe-visibility";
import titleMixin from "./mixins/titleMixin";

import "@/assets/scss/main.scss";
import { formatDateTime, monify } from "./utils/util";

Vue.prototype.gapi = window.gapi;
Vue.config.productionTip = false;

Vue.filter("phone", function (phone) {
  return phone
    .replace(/[^0-9]/g, "")
    .replace(/(\d{2})(\d{2})(\d{3})(\d{4})/, "+$1 $2 $3 $4");
});

Vue.filter("empty", function (data) {
  return data ? data : "-";
});

Vue.filter("thousand", function (data) {
  return data ? Number(data).toLocaleString() : "-";
});

Vue.filter("dateTime", function (data) {
  return data ? formatDateTime(data) : "-";
});

Vue.filter("monify", function (data) {
  return data ? monify(data) : "-";
});

Vue.use(VueObserveVisibility);
Vue.mixin(titleMixin);

Vue.use(Buefy, {
  defaultToastPosition: "is-bottom",
  defaultSnackbarPosition: "is-bottom",
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fa",
  customIconPacks: {
    fas: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x",
      },
      iconPrefix: "",
    },
  },
});

Vue.use(VueMask);
Vue.use(VeeValidate);
Vue.use(FontAwesome);
Vue.use(PortalVue);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
